module.exports = __webpack_public_path__ + "d05c310ce37da9f4d8fca1ce52c35409.jpg";